export class SupportService {
    constructor(supportService) {
        this.id = supportService.id;
        this.name = supportService.name;
        this.link = supportService.link;
    }
}